var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.637695,
    y: 3.9624,
    width: 8.29216,
    height: 12.5481,
    rx: 1.02209,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80919 3.84984L1.81536 3.80604C1.93264 2.97363 2.70251 2.3939 3.53492 2.51117L9.60186 3.36593C10.4343 3.4832 11.014 4.25307 10.8967 5.08548L9.445 15.3896C9.33378 16.1791 8.60363 16.7289 7.81417 16.6177V16.6177",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25278 2.59905L5.4998 2.10314C5.87462 1.3507 6.78844 1.04457 7.54088 1.41938L13.1354 4.20618C13.8871 4.58061 14.1935 5.49307 13.8201 6.24528L9.48886 14.9721",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsIcon);
export default __webpack_public_path__ + "static/media/cards-icon.3f3f21c9606ec0bc040b209738d82e01.svg";
export { ForwardRef as ReactComponent };